import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_434: DocMigration = {
  maxSchemaVersion: "0.0.434",
  description: "Remove redundant entityRefs for system entities",
  apply(json: any) {
    for (const entityRefId in json.entityRefs) {
      const entityRef = json.entityRefs[entityRefId];
      if (
        isBasePresetId(entityRef.id) ||
        isSystemOptionSetId(entityRef.id) ||
        isSystemGroup(json.groups[entityRef.id]) ||
        isSystemEntityTag(entityRef.id)
      ) {
        delete json.entityRefs[entityRefId];
      }
    }

    return json;
  },
};

function isBasePresetId(presetId: string) {
  return presetId === "Base Options";
}

function isSystemOptionSetId(optionSetId: string) {
  return ["elevationStyle", "mirror", "interiorPalette"].includes(optionSetId) || optionSetId.endsWith("settingsParam");
}

function isSystemGroup(entity: any) {
  return entity && entity.entityType === "GROUP" && entity.isBuiltIn;
}

function isSystemEntityTag(entityTagId: string) {
  return [
    "addToElectricalPlan",
    "addToFloorPlan",
    "addToFoundationPlan",
    "addToStructuralPlan",
    "addToShowroomPlan",
    "addToBrochurePlan",
    "addToFloorMaterialsPlan",
    "addToFloorSummaryPlan",
    "addToRoofPlan",
    "addToUtilityPlan",
  ].includes(entityTagId);
}

export default migration_0_0_434;
